import cssjanus from 'cssjanus'

import {STYLIS_PROPERTY_CONTEXT, StylisContextType} from './stylis'

export default (
  context: StylisContextType,
  content: string
): string | null | undefined => {
  if (context === STYLIS_PROPERTY_CONTEXT) {
    return cssjanus.transform(content)
  }
}

export * from './stylis'
